/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
    if (arguments.length === 0 || !time) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if (typeof time === 'string') {
            if (/^[0-9]+$/.test(time)) {
                // support "1548221490638"
                time = parseInt(time)
            } else {
                // support safari
                // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
                time = time.replace(new RegExp(/-/gm), '/')
            }
        }

        if (typeof time === 'number' && time.toString().length === 10) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') {
            return ['日', '一', '二', '三', '四', '五', '六'][value]
        }
        return value.toString().padStart(2, '0')
    })
    return time_str
}

export function isPhoneNumber(tel) {
    var reg = /^0?1[0-9][0-9]\d{8}$/
    return reg.test(tel)
}

export function rad(d) {
    return (d * Math.PI) / 180.0
}

// 根据经纬度计算距离，参数分别为第一点的纬度，经度；第二点的纬度，经度
export function getDistance(lng1, lat1, lng2, lat2) {
    var radLat1 = rad(lat1)
    var radLat2 = rad(lat2)
    var a = radLat1 - radLat2
    var b = rad(lng1) - rad(lng2)
    var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)))
    s = s * 6378.137 // EARTH_RADIUS;
    s = Math.round(s * 10000) / 10000 //输出为公里

    var distance = s
    var distance_str = ''

    if (parseInt(distance) >= 1) {
        distance_str = distance.toFixed(1) + 'KM'
    } else {
        distance_str = distance * 1000 + 'M'
    }

    //s=s.toFixed(4);

    // console.info('lyj 距离是', s);
    // console.info('lyj 距离是', distance_str);
    return { distance: s, distance_str: distance_str }
}

export function getQueryString(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    var r = window.location.search.substr(1).match(reg)
    if (r != null) {
        return unescape(r[2])
    }
    return null
}

export function isWeiXin() {
    // //获取访问终端的版本信息,如果终端信息中存在微信标识' micromessenger ',则是微信
    var ua = window.navigator.userAgent.toLowerCase()
    // var safari = ua.indexOf('safari') > -1 && ua.indexOf('chrome') == -1;
    // var chrome = ua.indexOf('safari') > -1 && ua.indexOf('chrome') > -1;
    var weixin = ua.match(/MicroMessenger/i) == 'micromessenger'
    return weixin

    // var huawei = ua.indexOf('huawei') > -1;
    // var honor = ua.indexOf('honor') > -1;
    // var oppo = ua.indexOf('oppo') > -1;
    // var vivo = ua.indexOf('vivo') > -1;
    // var mi = ua.indexOf('mi ') > -1;
    // var mi2S = ua.indexOf('mix ') > -1;
    // var redmi = ua.indexOf('redmi') > -1;
    // var aweme = ua.indexOf('aweme') > -1;

    // if (safari || weixin || huawei || honor || oppo || vivo || mi || mi2S || redmi || aweme) {
    //     return true;
    // } else {
    //     return false;
    // }
    console.log(ua)
    if (ua.match(/WeiBo/i) == 'weibo') {
        return false
    } else {
        // return false;
        return true
    }
}

export function isIos() {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

export function isAndorid() {
    var userAgent = navigator.userAgent
    var isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1
    return isiOS
}
export function isMobile() {
    const userAgentInfo = navigator.userAgent
    const mobileAgents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
    const mobileFlag = mobileAgents.some((mobileAgent) => {
        return userAgentInfo.indexOf(mobileAgent) > 0
    })

    return mobileFlag
}
export function isSafari() {
    if (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)) {
        return true
    } else {
        return false
    }
}
export function calcHeightCss(el) {
    var height = $('#app').height()
    console.log('height:', height)
    if (height < 1360) {
        $(el).addClass('minHeight') // 中间高度
        if (height < 1230) {
            $(el).addClass('minHeight1230') // 最小高度
        }
    }
}

export function sleep(time) {
    return new Promise((resolve, reject) => {
        setTimeout(function () {
            resolve()
        }, time)
    })
}

export function calcSize(value) {
    return value / 3.75 + 'vw'
}
export function calcValue(value){
    return  ($(window).width()/375)*value;
}

export function getUrlParam(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var p = window.location.href.split("?")[1];
    if (p) {
        var r = p.match(reg);
        if (r != null) {
            return decodeURIComponent(r[2]);
        }
    }
    return null;
}
